import groupOptionsByOptGroup from '../../utils/optGroup/optGroup';

/** @type {ReadonlySet<string>} */
const DASHBOARD_ACTION_TYPES = new Set([
  'reload',
  'openTab',
]);

/**
 * Flatten dashboard action items (oneOf) into actions carrying their type and a unique id
 * @param {Array<ApiDashboardActionItem> | null | undefined} items - The action items to flatten
 * @returns {Array<DashboardActionFlattened>} Flattened actions
 */
export const flattenDashboardActions = (items) => {
  if (!Array.isArray(items) || items.length === 0) return [];

  /** @type {DashboardActionFlattened[]} */
  const flattened = [];

  items.forEach((item, index) => {
    Object.entries(item ?? {}).forEach(([type, action]) => {
      if (!action || !DASHBOARD_ACTION_TYPES.has(type)) return;
      flattened.push(/** @type {DashboardActionFlattened} */ ({
        ...action,
        type,
        id: `${type}-${index}`,
      }));
    });
  });

  return flattened;
};

/**
 * Group dashboard actions by optGroup, with null/empty groups first
 * @param {Array<ApiDashboardActionItem> | null | undefined} items - The action items to group
 * @returns {Array<{lib: string, options: Array<DashboardActionFlattened>}>} Grouped actions
 */
export const groupDashboardActions = (items) => {
  const flattened = flattenDashboardActions(items);
  return groupOptionsByOptGroup(flattened);
};
